<app-header [showUserInfo]="false" [showHamburger]="false"></app-header>

<app-pan-card [isPageContainer]="true" header="403">
  <p>Access Denied</p>
  <p>You do not have permission to view this page.</p>
</app-pan-card>

<app-footer [public]="true" [copyright]="true"></app-footer>
